// extracted by mini-css-extract-plugin
export default {"like_button_container":"like-button_like_button_container__1IxKD"};